<template>
    <Breadcrumbs main="Buttons" title="Button Group" />
    <div class="container-fluid">
        <div class="row">
            <basicGroup />
            <edgesGroup />
            <flatGroup />
            <largeGroup />
            <largeEdges />
            <outlineGroup />
            <outlineCustom />
            <outlineButton />
            <outlineEdges />
            <outlineFlat />
            <radioButton />
            <checkboxButton />
            <nestingGroup />
            <verticalGroup />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const basicGroup = defineAsyncComponent(() => import("@/components/theme/buttons/group/basicGroup.vue"))
const edgesGroup = defineAsyncComponent(() => import("@/components/theme/buttons/group/edgesGroup.vue"))
const flatGroup = defineAsyncComponent(() => import("@/components/theme/buttons/group/flatGroup.vue"))
const largeGroup = defineAsyncComponent(() => import("@/components/theme/buttons/group/largeGroup.vue"))
const largeEdges = defineAsyncComponent(() => import("@/components/theme/buttons/group/largeEdges.vue"))
const outlineGroup = defineAsyncComponent(() => import("@/components/theme/buttons/group/outlineGroup.vue"))
const outlineCustom = defineAsyncComponent(() => import("@/components/theme/buttons/group/outlineCustom.vue"))
const outlineButton = defineAsyncComponent(() => import("@/components/theme/buttons/group/outlineButton.vue"))
const outlineEdges = defineAsyncComponent(() => import("@/components/theme/buttons/group/outlineEdges.vue"))
const outlineFlat = defineAsyncComponent(() => import("@/components/theme/buttons/group/outlineFlat.vue"))
const radioButton = defineAsyncComponent(() => import("@/components/theme/buttons/group/radioButton.vue"))
const checkboxButton = defineAsyncComponent(() => import("@/components/theme/buttons/group/checkboxButton.vue"))
const nestingGroup = defineAsyncComponent(() => import("@/components/theme/buttons/group/nestingGroup.vue"))
const verticalGroup = defineAsyncComponent(() => import("@/components/theme/buttons/group/verticalGroup.vue"))
</script>